import { assignJob, getFreePopulation, MAX_SAWMILLERS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireSawmillerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.sawmill.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_SAWMILLERS * settlement.buildings.sawmill.qty;
    if (settlement.jobs.sawmillers >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'sawmillers')) return false;
    return true;
};
